module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "leave-active-class": "animated zoomOut"
    }
  }, [_c('li', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "template-cover-wrapper"
  }, [_c('div', {
    staticClass: "template-overlay"
  }, [_c('span', {
    staticClass: "button is-primary is small",
    on: {
      "click": function($event) {
        _vm.$router.push('/a/template/' + _vm.template.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('templates.edit')))]), _vm._v(" "), _c('div', {
    staticClass: "template-hover-bottom"
  }, [_c('span', {
    attrs: {
      "title": "Make a Copy"
    }
  }, [_c('i', {
    staticClass: "icon icon-doc-copy",
    on: {
      "click": function($event) {
        _vm.duplicate()
      }
    }
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "Delete Template"
    }
  }, [_c('i', {
    staticClass: "icon icon-trash",
    on: {
      "click": function($event) {
        _vm.archive()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "template-cover",
    class: _vm.classes,
    style: ({
      'color': _vm.template.cover.color,
      'background-color': _vm.template.cover.backgroundColor,
      'font-family': _vm.template.options.documentFont
    })
  }, [_c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.template.cover.logo),
      expression: "template.cover.logo"
    }],
    attrs: {
      "src": _vm.template.cover.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-client-block"
  }, [_c('div', {
    staticClass: "document-title-input",
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.template.cover.title))]), _vm._v(" "), _c('div', {
    staticClass: "client-input",
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.template.cover.client))])]), _vm._v(" "), _c('div', {
    staticClass: "created-wrapper"
  }, [_c('span', {
    staticClass: "created-by"
  }, [_c('strong', {
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.$t('templates.created_by')))]), _vm._v(" "), _c('span', {
    staticClass: "created-by-input",
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.template.cover.createdBy))])]), _vm._v(" "), _c('span', {
    staticClass: "created-for"
  }, [_c('strong', {
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.$t('templates.created_for')))]), _vm._v(" "), _c('span', {
    staticClass: "created-for-input",
    style: ({
      'color': _vm.template.cover.color
    })
  }, [_vm._v(_vm._s(_vm.template.cover.createdFor ? _vm.template.cover.createdFor : _vm.$t('templates.n-a')))])])]), _vm._v(" "), (_vm.template.cover.backgroundImage) ? _c('span', {
    staticClass: "has-bg-img",
    style: ({
      'background-image': 'url(' + _vm.template.cover.backgroundImage + ')'
    })
  }) : _vm._e()])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.template.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148ef2c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/template-card.vue
// module id = 509
// module chunks = 0